import React from "react";

const ZipCodeDropdown = ({ zipCodes, selectedZipCode, onChange, detectUserLocation, detectingLocation }) => {
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium mb-1">Zip Code:</label>
      <div className="flex">
        <select className="w-full p-2 border rounded" value={selectedZipCode} onChange={onChange}>
          <option value="">All Zip Codes</option>
          {zipCodes.map((zip) => (
            <option key={zip} value={zip}>{zip}</option>
          ))}
        </select>
        
      </div>
    </div>
  );
};

export default ZipCodeDropdown;
